import {
  createStyles,
  makeStyles,
  TableCell,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import { Check } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';

export interface TableCellCheckIconProps {
  checked: boolean;
  contentAction?: ContentActionGq;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    extraCellPadding: {
      width: '118px',
      paddingRight: '40px',
    },
    checkIcon: {
      color: theme.palette.grey[700],
    },
    hideCheckIcon: {
      color: 'transparent',
    },
    naText: {
      color: theme.palette.grey[400],
    },
  })
);

const TableCellCheckIcon: React.FC<TableCellCheckIconProps> = React.memo(
  ({ checked, contentAction }) => {
    //Styling
    const theme = useTheme();
    const classes = useClasses(theme);

    return (
      <TableCell align={'center'} className={classes.extraCellPadding}>
        {contentAction === ContentActionGq.CREATE || contentAction === ContentActionGq.MISSING ? (
          <Typography variant={'body2'} className={classes.naText}>
            N/A
          </Typography>
        ) : (
          <Check
            fontSize={'small'}
            className={clsx({
              [classes.hideCheckIcon]: !checked,
              [classes.checkIcon]: checked,
            })}
          />
        )}
      </TableCell>
    );
  }
);

export default TableCellCheckIcon;
